module.exports = __webpack_public_path__ + "static/media/Visa.b1684820.svg";